import { render, staticRenderFns } from "./InventoryUniforms.vue?vue&type=template&id=ad7ad7f6&scoped=true"
import script from "./InventoryUniforms.vue?vue&type=script&lang=js"
export * from "./InventoryUniforms.vue?vue&type=script&lang=js"
import style0 from "./InventoryUniforms.vue?vue&type=style&index=0&id=ad7ad7f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad7ad7f6",
  null
  
)

export default component.exports